import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3be7c809"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Units Grid View", -1))
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = {
  key: 0,
  class: "row horizontal-start"
}
const _hoisted_4 = ["onMouseover"]
const _hoisted_5 = {
  key: 0,
  class: "detail"
}
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Unit", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Override Price Plan", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("months")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" month")
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Customer", -1))
const _hoisted_17 = {
  key: 1,
  class: "container"
}
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"container\" data-v-3be7c809><h2 data-v-3be7c809>Legend</h2><div class=\"row legend\" data-v-3be7c809><div class=\"auction\" data-v-3be7c809>Auction</div><div class=\"available\" data-v-3be7c809>Available</div><div class=\"late\" data-v-3be7c809>Late</div><div class=\"lien\" data-v-3be7c809>Lien</div><div class=\"locked_out\" data-v-3be7c809>Locked Out</div><div class=\"moving_out\" data-v-3be7c809>Moving Out</div><div class=\"pending\" data-v-3be7c809>Pending</div><div class=\"pre_lien\" data-v-3be7c809>Pre-Lien</div><div class=\"rented\" data-v-3be7c809>Rented</div><div class=\"reserved\" data-v-3be7c809>Reserved</div><div class=\"unavailable\" data-v-3be7c809>Unavailable</div></div></div>", 1)
const _hoisted_19 = { key: 0 }

import { ref } from "vue";

import api from "@virgodev/bazaar/functions/api";
import { UnitInterface, UnitTypeInterface } from "@/types/unit";
import BaseSpinner from "@/components/BaseSpinner.vue";
import { CustomerDataInterface, RentalInterface } from "@/types/customers";

export default /*#__PURE__*/_defineComponent({
  props: {
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const customers = ref(Array<CustomerDataInterface>());
const units = ref(Array<UnitInterface>());
const status = ref("loading");

const unitTypes = ref(Array<UnitTypeInterface>());
const errors = ref("");
const hover = ref(-1);
const rentals = ref();
function hoverUnit(id: string) {
  hover.value = Number(id);
}


async function getUnits() {
  // await getAllUnitTypes();
  await getRentals();
  await getCustomers();
  errors.value = "";
  const response = await api({
    url: `units/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    units.value = response.body;
    for (let unit of units.value) {
      unit.customer = null;
      if (unit.status != "available") {
        let rental = rentals.value.filter(
          (item: RentalInterface) => item.unit_id == Number(unit.id)
        )[0];
        if (rental) {
          unit.rental = rental;
        }
        let customer = customers.value.filter(
          (item: CustomerDataInterface) => Number(item.id) == unit.customer_id
        )[0];
        unit.customer = customer;
      }
    }

    await getAllUnitTypes();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  status.value = "completed";
}
async function getRentals() {
  errors.value = "";
  const response = await api({
    url: `rentals/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    rentals.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  return null;
}
async function getCustomers() {
  errors.value = "";
  const response = await api({
    url: `customers/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    customers.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getAllUnitTypes() {
  errors.value = "";
  const response = await api({
    url: `unit_types/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unitTypes.value = response.body;
    for (let unitType of unitTypes.value) {
      unitType.units = units.value.filter(
        (item) => item.unit_type_id == Number(unitType.id)
      );
      let plans = await getPlans(Number(unitType.id));
      unitType.plans = plans.filter(
        (item: { amount: number }) => item.amount && item.amount > 0
      );
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getPlans(unit_type_id: number) {
  errors.value = "";
  let url = `plans/?facilityId=${props.facilityId}&unit_type_id=${unit_type_id}`;

  const response = await api({
    url,
  });
  if (response.status == 200) {
    return response.body;
  } else {
    return null;
  }
}
// async function getUnitTypes(id: string) {
//   errors.value = "";
//   console.log("called", id);
//   const response = await api({
//     url: `unit_types/?id=${id}&facilityId=${props.facilityId}`,
//   });
//   if (response.status == 200) {
//     unitTypes.value[Number(id)] = response.body;
//   } else {
//     errors.value =
//       "Unable to communicate with the server. Please check your " +
//       "connection and try again.";
//   }
// }
getUnits();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("fieldset", null, [
      (status.value === 'loading')
        ? (_openBlock(), _createBlock(BaseSpinner, {
            key: 0,
            preset: "large"
          }))
        : _createCommentVNode("", true),
      (units.value && unitTypes.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitTypes.value, (unitType) => {
              return (_openBlock(), _createElementBlock("div", {
                key: unitType.id + 'unitType'
              }, [
                _createElementVNode("h1", null, [
                  (unitType.length != 0 && unitType.width != 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (
                unitType.name &&
                unitType.name.includes(unitType.length.toString()) &&
                unitType.name.includes(unitType.width.toString())
              )
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(unitType.name), 1)
                            ], 64))
                          : (
                unitType.name &&
                !unitType.name.includes(unitType.length.toString()) &&
                !unitType.name.includes(unitType.width.toString())
              )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(unitType.length) + " x " + _toDisplayString(unitType.width) + " - " + _toDisplayString(unitType.name), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(unitType.length) + " x " + _toDisplayString(unitType.width) + " ", 1),
                                (unitType.name)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" - (" + _toDisplayString(unitType.name) + ")", 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(unitType.name), 1)
                      ], 64))
                ]),
                (unitType.units && unitType.units.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitType.units, (unit) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: unit.id + 'unitTypeUnit',
                          onMouseover: ($event: any) => (hoverUnit(unit.id)),
                          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (hoverUnit((-1).toString())))
                        }, [
                          _createVNode(_component_RouterLink, {
                            to: {
                name: 'unit_detail_ess',
                params: { id: unit.id, facilityId: __props.facilityId },
              },
                            class: _normalizeClass(["box", unit.status])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(unit.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "class"]),
                          (hover.value == Number(unit.id))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("b", null, [
                                    _createTextVNode(_toDisplayString(unit.name) + " - ", 1),
                                    (unitType.length != 0 && unitType.width != 0)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(unitType.length) + " x " + _toDisplayString(unitType.width), 1)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(unitType.name), 1)
                                        ], 64))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                  _hoisted_8,
                                  _createElementVNode("p", null, "Status: " + _toDisplayString(unit.status), 1),
                                  (unit.status == 'available')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                        _createTextVNode(" Price: " + _toDisplayString(unitType.price) + " Each Month ", 1),
                                        (unitType.plans && unitType.plans.length)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _hoisted_10,
                                              _hoisted_11,
                                              _hoisted_12,
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitType.plans, (plan) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: plan.id + 'plan'
                                                }, [
                                                  (plan.amount)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createTextVNode(" $ " + _toDisplayString(plan.amount) + " per " + _toDisplayString(plan.months) + " ", 1),
                                                        (plan.months > 1)
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                              _hoisted_13
                                                            ], 64))
                                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                              _hoisted_14
                                                            ], 64))
                                                      ], 64))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (unit.customer)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _hoisted_16,
                                        _createElementVNode("p", null, "Name: " + _toDisplayString(unit.customer.name), 1),
                                        _createElementVNode("p", null, "Phone: " + _toDisplayString(unit.customer.phone), 1),
                                        _createElementVNode("p", null, "Cell Phone: " + _toDisplayString(unit.customer.cell_phone), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 40, _hoisted_4))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, "No units for this unit type"))
              ]))
            }), 128)),
            _hoisted_18
          ]))
        : _createCommentVNode("", true)
    ]),
    (errors.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(errors.value), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})